module.exports = __webpack_public_path__ + "static/media/image-third-strip.0784fc1b.svg";